module.exports = __webpack_public_path__ + "static/media/dishes.e96ff44e.png";